import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import type { SessionValue } from "@/auth/session";
import { NotFoundPage } from "@/components/pages";

export interface RouterContext {
  session: SessionValue;
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFoundPage,
});
